export default "__VITE_ASSET__692c2674__"